module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('span', [_c('svg', {
    staticClass: "close-button",
    attrs: {
      "viewBox": "0 0 256 256",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('path', {
    attrs: {
      "d": "M137.05 128l75.476-75.475c2.5-2.5 2.5-6.55 0-9.05s-6.55-2.5-9.05 0L128 118.948 52.525 43.474c-2.5-2.5-6.55-2.5-9.05 0s-2.5 6.55 0 9.05L118.948 128l-75.476 75.475c-2.5 2.5-2.5 6.55 0 9.05 1.25 1.25 2.888 1.876 4.525 1.876s3.274-.624 4.524-1.874L128 137.05l75.475 75.476c1.25 1.25 2.888 1.875 4.525 1.875s3.275-.624 4.525-1.874c2.5-2.5 2.5-6.55 0-9.05L137.05 128z"
    }
  })])]), _vm._v(" "), _c('header', [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20be75f3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalBase.vue
// module id = 668
// module chunks = 2